import { defaultHttpClient } from '../../httpClient';
import type { GetBeautyInfoResponse } from './types';

export const getBeautyInfo = async () => {
  return defaultHttpClient
    .request<GetBeautyInfoResponse>({
      method: 'GET',
      url: '/api/v2/members/me/beauty/info/',
    })
    .then(result => result.data);
};
